'use strict'
import { initState } from './state'
import { has, get } from 'lodash-es'
import { Toast } from 'vant'
import { promoteUrl } from "@/utils/url";
import Loader from '@/utils/loader'

const actions = {
  // 重置
  reset ({ commit }) {
    commit('setIsLogin', false)
    commit('setIsAdmin', false)
    commit('setUserInfo', initState.userInfo)
    commit('setTaskList', initState.taskList)
    commit('setPalcodeInfo', initState.palcodeInfo)
  },
  // 用戶資料
  updateUserInfo ({ commit }, data = {}) {
    commit('setIsLogin', true)
    commit('setIsAdmin', data.is_admin || false)
    commit('setUserInfo', data)
  },
  // 登出
  async logout ({ dispatch }) {
    dispatch("common/handleLoading", true, { root: true })
    dispatch("common/closeRedirectLoadingInterval", {}, { root: true })
    window.location.href = promoteUrl() + '/member.php?mod=logging&action=logout&v=vue'
    // dispatch('reset')
  },
  // 取得用户信息
  async getUserInfoV2({ commit, dispatch, rootState }, params = {}) {
    try {
      const { getUserInfoAPI } = await import('@/api/')
      const { head, body } = await getUserInfoAPI(params)
      if(+head.errCode !== 0) {
        throw new Error(`errCode:${head.errCode}, errMsg:${head.errMsg}`)
      } else if(body && Object.keys(body).length > 0) {
        dispatch('updateUserInfo', body)
        return true;
      }
      dispatch('reset')
      console.log('not login');
      return false
    } catch (error) {
      dispatch('reset')
      console.log(error);
      return false
    }
  },

  // 取得用户信息
  async getUserInfo ({ commit, dispatch, rootState }, params = {}) {
    const { getUserInfoAPI } = await import('@/api/')
    return new Promise(async (resolve, reject) => {

      Loader.loading() // 因为可能要打第二支接口
      const response = await getUserInfoAPI(params)

      // TODO: dispatch('reset') 会触发两次, 待修正判断式

      if (has(response, 'body') && Object.keys(response.body).length === 0) {
        dispatch('reset')
        resolve(response.body)
      }

      if (has(response, 'body')) {
        if (Object.keys(response.body).length > 0) {
          // 登入狀態
          dispatch('updateUserInfo', response.body)
        } else {
          // 未登入狀態
          dispatch('reset')
        }
        Loader.cancel()
        resolve(response.body)
      }
      reject(get(response, 'data.head', {}))
    })
  },
  // 取得用户任务列表
  async getTaskList ({ commit }) {
    Loader.loading()
    const { getTaskListAPI } = await import('@/api/')
    return new Promise(async (resolve, reject) => {
      const response = await getTaskListAPI()
      Loader.cancel()
      if (has(response, 'data')) {
        commit('setTaskList', response.data)
        resolve(response.data)
      }
      reject(get(response, 'data.head', {}))
    })
  },
  // 取得用户邀请码
  async getPalcodeInfo ({ commit, dispatch }) {
    Loader.loading()
    const { getPalcodeInfoAPI } = await import('@/api/')
    const response = await getPalcodeInfoAPI()
    await dispatch('getTaskList')
    Loader.cancel()
    if (has(response, 'data')) {
      commit('setPalcodeInfo', response.data)
      return response.data
    } else {
      Toast({
        message: response.msg,
      })
      return response.data
    }
  },
  // 取得用户帖子总数
  async getMyThreadTotal () {
    const { getMyThreadAPI } = await import('@/api/')
    const response = await getMyThreadAPI({
      page: 1,
      perpage: 20
    })
    if (response?.body?.list) {
      return +response.body.page_info.total
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return 0
    }
  },
  // 取得用户帖子
  async getMyThread ({ state, rootGetters, commit }, { page = 1, pageSize = 20, uid }) {
    Loader.loading()
    const params = {
      page,
      perpage: pageSize,
      ta_uid: uid
    }
    const { getMyThreadAPI } = await import('@/api/')
    const response = await getMyThreadAPI(params)
    Loader.cancel()
    if (response?.body) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info?.total, // 总笔数
        page: response.body.page_info?.current_page, // 第几页
        pages: response.body.page_info?.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.myThread.list, ...result.list]
        commit('setMyThread', {
          ...result,
          list: collageList
        })
      } else {
        commit('setMyThread', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  // 取得用户回复
  async getMyReply ({ state, rootGetters, commit }, { page = 1, pageSize = 20 }) {
    Loader.loading()
    const params = {
      page,
      perpage: pageSize
    }
    const { getMyReplyAPI } = await import('@/api/')
    const response = await getMyReplyAPI(params)
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.myReply.list, ...result.list]
        commit('setMyReply', {
          ...result,
          list: collageList
        })
      } else {
        commit('setMyReply', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  // 取得用户打赏
  async getMyDonate ({ state, rootGetters, commit }, { page = 1, pageSize = 20, uid }) {
    Loader.loading()
    const params = {
      page,
      perpage: pageSize,
      ta_uid: uid
    }
    const { getMyDonateAPI } = await import('@/api/')
    const response = await getMyDonateAPI(params)
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.myDonate.list, ...result.list]
        commit('setMyDonate', {
          ...result,
          list: collageList
        })
      } else {
        commit('setMyDonate', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  // 取得用户收藏
  async getMyFavorite ({ state, rootGetters, commit }, { page = 1, pageSize = 20, uid }) {
    Loader.loading()
    const params = {
      page,
      perpage: pageSize,
      ta_uid: uid
    }
    const { getMyFavoriteAPI } = await import('@/api/')
    const response = await getMyFavoriteAPI(params)
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.myFavorite.list, ...result.list]
        commit('setMyFavorite', {
          ...result,
          list: collageList
        })
      } else {
        commit('setMyFavorite', result)
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  // 取得用户私人信息
  async gePersonalNotice ({ state, rootGetters, commit }, { page = 1, pageSize = 20 }) {
    Loader.loading()
    const { gePersonalNoticeAPI, geUnreadNoticeTotalAPI } = await import('@/api/')
    const [
      response,
      responseOfTotal
    ] = await Promise.all(
      [
        gePersonalNoticeAPI({
          page,
          perpage: pageSize
        }),
        geUnreadNoticeTotalAPI({
          type: 'post'
        })
      ]
    )
    console.log('response', response)
    console.log('responseOfTotal', responseOfTotal)
    Loader.cancel()
    const unread = has(responseOfTotal, 'body') ? responseOfTotal.body?.list?.total || 0 : 0
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.myPersonalNotice.list, ...result.list]
        commit('setMyPersonalNotice', {
          ...result,
          list: collageList,
          unread
        })
      } else {
        commit('setMyPersonalNotice', {
          ...result,
          unread,
        })
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },
  // 取得用户系统消息
  async getSystemNotice ({ state, rootGetters, commit }, { page = 1, pageSize = 20 }) {
    Loader.loading()
    const { getSystemNoticeAPI, geUnreadNoticeTotalAPI } = await import('@/api/')
    const [
      response,
      responseOfTotal
    ] = await Promise.all(
      [
        getSystemNoticeAPI({
          page,
          perpage: pageSize
        }),
        geUnreadNoticeTotalAPI({
          type: 'system'
        })
      ]
    )
    console.log('response', response)
    console.log('responseOfTotal', responseOfTotal)
    const unread = has(responseOfTotal, 'body') ? responseOfTotal.body?.list?.total || 0 : 0
    Loader.cancel()
    if (response?.body?.list) {
      const result = {
        list: response.body.list || [],
        pageSize, // 一页几笔
        total: +response.body.page_info.total, // 总笔数
        page: response.body.page_info.current_page, // 第几页
        pages: response.body.page_info.pages, // 总页数
      }
      // H5 需要拼贴结果
      if (rootGetters.isH5View) {
        const collageList = result.page === 1 ? result.list : [ ...state.mySystemNotice.list, ...result.list]
        commit('setMySystemNotice', {
          ...result,
          list: collageList,
          unread
        })
      } else {
        commit('setMySystemNotice', {
          ...result,
          unread
        })
      }
      return result
    } else {
      // TODO: 错误处理
      // Toast({
      //   message: response.head.errMsg,
      // })
      return response.head
    }
  },

  async deleteNoticeById ({ state }, { target = '', id = '' }) {
    // TODO: 是否要做提示窗 ?
    let listDataTarget = ''
    if (target === 'personal') listDataTarget = 'myPersonalNotice'
    if (target === 'system') listDataTarget = 'mySystemNotice'
    if (!state[listDataTarget]?.list || !id) return
    Loader.loading()
    const { delNoticeAPI } = await import('@/api/')
    const response = await delNoticeAPI({
      'type': 'byid',
      'id': id,
    })
    Loader.cancel()
    if (response?.body?.status === 200) {
      const removeIndex = state[listDataTarget]?.list.findIndex((el) => el.id === id)
      const isNew = state[listDataTarget]?.list.find((el) => el.id === id)?.new === "1"
      if (removeIndex >= 0) {
        state[listDataTarget]?.list.splice(removeIndex, 1)
      }
      if (state[listDataTarget].unread > 0 && isNew) state[listDataTarget].unread--
      Toast({
        message: '消息已删除'
      })
    } else {
      Toast({
        message: '消息删除失败'
      })
    }
  },
  // 取得用户2022年度回憶
  async getMemories ({ commit }) {
    Loader.loading()
    const { getMemoriesAPI } = await import('@/api/')
    const response = await getMemoriesAPI({ showError:false })
    Loader.cancel()
    // console.log('res >>> ', response)
    if (has(response, 'body')) {
      commit('setMemories', response.body)
    }
    if (has(response, 'head.errCode')) {
      if (response.head.errCode === 1002 ) commit('setMemories', null)
    }
    return response
  },
}

export default actions
